import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import hu from './locales/hu.json';
import en from './locales/en.json';

const STORAGE_KEY = 'tracemop_lang';

const saved = typeof window !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;
const initialLang = saved === 'en' || saved === 'hu' ? saved : 'hu';

i18n.use(initReactI18next).init({
  resources: {
    hu: { translation: hu },
    en: { translation: en },
  },
  lng: initialLang,
  fallbackLng: 'hu',
  interpolation: { escapeValue: false },
});

i18n.on('languageChanged', (lng) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, lng);
    document.documentElement.lang = lng;
  }
});

if (typeof document !== 'undefined') {
  document.documentElement.lang = initialLang;
}

export default i18n;
